import { type PropsWithChildren } from "react"
import { Link, type LinkProps, Typography } from "@octopus-energy/coral/atoms"
import { FormikCheckbox, type FormikCheckboxProps } from "@octopus-energy/coral/formik"
import { useTranslations } from "next-intl"

function PrivacyPolicyCheckbox({
    linkProps,
    ...props
}: Omit<FormikCheckboxProps, "label"> & { linkProps?: LinkProps }) {
    const t = useTranslations("PrivacyPolicy")

    return (
        <FormikCheckbox
            attributes={{ "data-testid": "privacyPolicyCheckbox" }}
            {...props}
            label={t.rich("label", {
                Link: (chunks) => (
                    <Link
                        download
                        target="_blank"
                        {...linkProps}
                    >
                        {chunks}
                    </Link>
                ),
            })}
        />
    )
}

type PrivacyPolicyProps = PropsWithChildren<{
    isTitleDisplay?: boolean
}>

export function PrivacyPolicy({ children, isTitleDisplay = true }: PrivacyPolicyProps) {
    const t = useTranslations("PrivacyPolicy")

    return (
        <>
            {isTitleDisplay && (
                <Typography
                    textStyle="h3"
                    textAlign="center"
                    attributes={{ "data-testid": "privacyPolicyTitle" }}
                >
                    {t("title")}
                </Typography>
            )}
            {children}
        </>
    )
}

PrivacyPolicy.messages = ["PrivacyPolicy"] as const
PrivacyPolicy.Checkbox = PrivacyPolicyCheckbox
